import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import dayjs from 'dayjs';
import { Avatar, Tooltip } from 'antd';
import { PrakurtiCirculerLogo } from '../../../../components/imagepath';

const PatientNameCell = ({ record, bookingStats, bookingColorMap }) => {
    const bookingId = record?.orderId?._id;
    const isSimulation = record?.isSimulation;
    const isCaretaker = record && Object.prototype.hasOwnProperty.call(record, 'patientPlanId') && record.patientPlanId === null;

    const admissionDate = record?.admissionDate;
    const dischargeDate = record?.dischargeDate;
    const totalDays = admissionDate && dischargeDate
        ? dayjs(dischargeDate).diff(dayjs(admissionDate), 'day')
        : 0;

    return (
        <Link
            to={`/patient-list/patient-profile/${record?.patientId?._id || record?.patientId?.id}`}
            className="patient-name-cell"
            style={{ background: bookingColorMap[bookingId] }}
        >
            <div className="guest-info-wrapper">
                <div className="guest-icon">
                    {isSimulation ? (
                        <Tooltip title="Simulation Booking">
                            <Avatar src={PrakurtiCirculerLogo} size={16} />
                        </Tooltip>
                    ) : (
                        <FeatherIcon icon="user" size={16} />
                    )}
                </div>
                <div className="guest-details">
                    <div className="d-flex align-items-center overflow-hidden">
                        <Tooltip title={record?.patientId?.name || 'N/A'}>
                            <span className="guest-name text-truncate">
                                {record?.patientId?.name || 'N/A'}
                            </span>
                        </Tooltip>
                    </div>
                    <div className="guest-meta">
                        {isCaretaker ? (
                            <span className="caretaker-badge">Caretaker</span>
                        ) : (
                            record?.orderId?.bookingFor && (
                                <span className="booking-for-chip">
                                    {record?.orderId?.bookingFor}
                                </span>
                            )
                        )}
                        <span className="days-stay-chip">
                            <FeatherIcon icon="clock" size={10} style={{ marginRight: '2px' }} />
                            {totalDays} {totalDays === 1 ? 'Day' : 'Days'}
                        </span>
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default PatientNameCell;
